import { JoonAdminApiMerchant } from 'Services/JOONAdmin/adminApiResponseTypes'
import { JoonAdminMerchant } from 'Utils/types/merchant'

export const parseJoonAdminMerchantApiResponseData = (
  joonAdminApiMerchant: JoonAdminApiMerchant
): JoonAdminMerchant => ({
  ...joonAdminApiMerchant
})
